import * as React from "react"

/* This example requires Tailwind CSS v2.0+ */
export default function RebuttingMyOpponentsAttacksDoc() {
  return (
    <>
      <div className="bg-gray-200">
        <div className="relative max-w-7xl mx-auto pt-5 pb-10 px-6 xl:px-0 text-center">
          <div>
            <span className="text-xl">(<a href="https://docs.google.com/document/d/e/2PACX-1vTSKnWOomNYfDpzIUh2ZcnKyWVNn0lKknrz95darL3QqKxAPOBtEUlytfuutiHAJ76I6DHQOTAt8SXf/pub" target="_blank">view full-size doc</a>)</span>
            <iframe className="border mt-5 mx-auto w-full xs:w-full sm:w-full md:w-full lg:w-3/5 xl:w-3/5" src="https://docs.google.com/document/d/e/2PACX-1vTSKnWOomNYfDpzIUh2ZcnKyWVNn0lKknrz95darL3QqKxAPOBtEUlytfuutiHAJ76I6DHQOTAt8SXf/pub?embedded=true"  height="655" frameborder="0" marginheight="0" marginwidth="0"></iframe>
          </div>
        </div>
      </div>
    </>
  )
}
